import PropTypes from 'prop-types';
import { Component } from 'react';

// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import CreateTaskActionMetadata from 'automation-ui-action-features/actions/create-task/records/CreateTaskActionMetadata';
import CreateTaskActionDetail from 'automation-ui-action-features/actions/create-task/CreateTaskActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class CreateTaskActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      flowObjectTypeId,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(CreateTaskActionDetail, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    });
  }
}
CreateTaskActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(CreateTaskActionMetadata).isRequired,
  actionLabel: PropTypes.node,
  flowObjectTypeId: ObjectTypeIdType
};
export default CreateTaskActionHistoryCard;